import {StateCreator} from 'zustand'

interface GameEndControls {
    onClickStatsOrReplay: () => void
    onClickShareReplay: () => void
}

export interface GameEndSlice {
    gameEnd: {
        isVisible: boolean
        setIsVisible: (isVisible: boolean) => void
        endControls?: GameEndControls
        setEndControls: (endControls: GameEndControls) => void
    }
}

export const createGameEndSlice = (): StateCreator<GameEndSlice> => (set, get) => ({
    gameEnd: {
        isVisible: false,
        setIsVisible: (isVisible) => set({
            gameEnd: {
                ...get().gameEnd,
                isVisible: isVisible,
            },
        }),
        setEndControls: (endControls) => set({
            gameEnd: {
                ...get().gameEnd,
                endControls: endControls,
            },
        }),
    },
})
